import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { graph, breadcrumbList, faqPage } from "@/lib/schema";
import { content } from "@/lib/content";
import { TopBar } from "@/components/TopBar";
import { Navbar } from "@/components/Navbar";
import { AboutContent } from "@/components/AboutContent";
import { Footer } from "@/components/Footer";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About IraqCert — ISO Certification & Vendor Registration Support" },
      {
        name: "description",
        content:
          "Based in Erbil, IraqCert supports companies across Iraq with ISO certification preparation and oil and gas vendor registration.",
      },
      { property: "og:title", content: "About IraqCert — ISO Certification & Vendor Registration Support" },
      {
        property: "og:description",
        content:
          "Based in Erbil, IraqCert supports companies across Iraq with ISO certification preparation and oil and gas vendor registration.",
      },
      { property: "og:url", content: absolute("/about") },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: absolute("/about") }, ...hreflangLinks("/about")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          graph(
            breadcrumbList([
              { name: "Home", path: "/" },
              { name: "About", path: "/about" },
            ]),
            faqPage(
              "/about",
              content.faq.about.map((f) => ({ q: f.q.en, a: f.a.en })),
            ),
          ),
        ),
      },
    ],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <Navbar />
      <main>
        <AboutContent />
      </main>
      <Footer />
    </div>
  );
}
